const forgotPassword = {
  toastr: 'Enlace enviado por email',
  toastr1: 'email enviado con éxito'
};

export default forgotPassword;
